import { styled } from "@mui/material";
import { StyledCard } from "../styledCard.styled";

type StyledQuoteCardProps = {
  opened: boolean;
};

export const StyledQuoteCard = styled(StyledCard)<StyledQuoteCardProps>(
  ({ theme, opened }) => ({
    gridArea: opened ? "2 / 1 / 14 / 4" : "8 / 3 / 14 / 4",
    zIndex: opened ? 99 : 0,
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      paddingBottom: "0",
    ".head": {
      marginBottom: "0",
      padding: ".25rem 1rem",
      h3: {
        fontSize: "1.2rem",
      },
      svg: {
        width: "24px"
      },
    },
  },
  })
);
